<template>
  <div class="mps-entity-editor vue-rqf bg-loading" :loading="$root.ui.loading">
    <div class="mps-admin-container">
      <h4>Innstillinger<span v-if="company.id" v-text="' for ' + company.name"></span></h4>
      <div class="mps-control">
        <label class="label" for="c-name">Navn</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="c-name" v-model="company.name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('name') }" name="name" type="text" placeholder="Name">
          <span v-show="errors.has('name')" class="help is-danger" v-text="errors.first('name')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-slug">Slug</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="c-slug" v-model="company.slug" v-validate="'required|slug'" :class="{'input': true, 'is-danger': errors.has('name') }" name="slug" type="text" placeholder="Slug">
          <span v-show="errors.has('slug')" class="help is-danger" v-text="errors.first('slug')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-email">Epost</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="c-email" v-model="company.email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" name="email" type="email" placeholder="Email">
          <span v-show="errors.has('email')" class="help is-danger" v-text="errors.first('email')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-discount">Discount (%)</label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input id="c-discount" v-model="company.discount" v-validate="'between:0,100'" :class="{ 'input': true, 'is-danger': errors.has('discount') }" name="discount" type="text" placeholder="Discount (%)">
          <span v-show="errors.has('discount')" class="help is-danger" v-text="errors.first('discount')"></span>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-type">Type</label>
        <div :class="['mps-input-wrap', 'mps-admin-select']">
          <v-select v-model="type" :options="types" label="slug"></v-select>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-status">Status</label>
        <div :class="['mps-input-wrap', 'mps-admin-select']">
          <v-select v-model="status" :options="statuses"></v-select>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-is_partner">
          <span>Is partner</span>
        </label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input true-value="1" false-value="0" id="c-is_partner" name="is_partner" type="checkbox" v-model="company.is_partner"/>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-is_fleet">
          <span>Is fleet</span>
        </label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input true-value="1" false-value="0" id="c-is_fleet" name="is_fleet" type="checkbox" v-model="company.is_fleet"/>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-disabled_workshops">Disabled workshops</label>
        <div :class="['mps-input-wrap', 'mps-admin-select']" style="max-width: 70%">
          <v-select placeholder="Velg verksted" multiple v-model="disabledWorkshops" :options="filteredWorkshops" label="name"></v-select>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-is_pdf_offer">
          <span>Add pdf to offer email.</span>
        </label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }">
          <input true-value="1" false-value="0" id="c-is_pdf_offer" name="is_pdf_offer" type="checkbox" v-model="company.is_pdf_offer"/>
        </div>
      </div>
      <div class="mps-control">
        <label class="label" for="c-logo">
          <span>Logo</span>
        </label>
        <div :class="{ 'control': true, 'mps-input-wrap': true }" style="width: 50%;">
          <div>
            <input id="c-logo" type="file" @change.prevent.stop="addImage($event)" accept="image/*">
            <img :src="file.url ? file.url : company.logo">
          </div>
        </div>
      </div>

      <div style="text-align: right">
        <button @click="saveCompany" :disabled="errors.any() || $root.ui.loading" class="mps-admin-btn big">Lagre</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    let statuses = [];
    statuses[0] = 'Not active';
    statuses[30] = 'Active';

    return {
      workshops: [],
      statuses: statuses,
      company: {
          "name": null,
          "slug": null,
          "email": null,
          "id_type": null,
          "status": 0,
          "is_partner": 0,
          "is_fleet": 0,
          "is_pdf_offer": 0,
          "discount": 0,
          "disabled_workshops": null,
          "logo": null
      },
      file: {
        url: null,
        input_file: null
      },
      types: []
    }
  },
  computed: {
    status: {
      get(){
        let status = parseInt(this.company.status);//this.statuses
        status = status ? status : 0;
        return this.statuses[status];
      },
      set(val){
          let v = this.statuses.indexOf(val);
        this.company.status = v>0 ? v : 0;
      }
    },
    type: {
      get: function () {
        for (var i = 0; i < this.types.length; i++) {
          let type = this.types[i];
          if(parseInt(type.id) == parseInt(this.company.id_type))
            return type
        }
        return null
      },
      set(type){
        if(type)
          this.company.id_type = type.id
        else
          this.company.id_type = null
      }
    },
    filteredWorkshops(){
        let self = this;
        if(self.company.is_fleet)
            return self.workshops.filter(function(ws, index){
              return parseInt( ws.status ) > 15 && ws.fleet_status ;
            });
        return self.workshops;
    },
    disabledWorkshops: {
        get(){
            if(this.company.disabled_workshops){
                let ids = this.company.disabled_workshops.match(/\d+/g).map(v => parseInt(v));

                console.log('JSON.stringify(this.company.disabled_workshops)')
                console.log(JSON.stringify(this.company.disabled_workshops))
                console.log('this.workshops')
                console.log(this.workshops)
                let yo = this.workshops.filter(function(ws, index){
                    return ids.indexOf( parseInt( ws.id ) ) != -1;
                });
                console.log('yo')
                console.log(yo)
                return yo;
            }

            return null;
        },
        set(workshops){
          console.log('set_workshops')
          console.log(workshops)
            if(workshops) {
                this.company.disabled_workshops = workshops.map((w) => {
                    return parseInt(w.id);
                }).join(",");
            }else{
                this.company.disabled_workshops = '';
            }
        }
    }
  },
  methods: {

      getCompany(){
          var self = this
          self.$root.ui.loading = true;

          return self.$api.getCompany( self.$route.params.id ).then(function( data ) {
            self.company = Object.assign(self.company, data);
            //self.workshop.is_svipps_partner = parseInt(self.workshop.is_svipps_partner) ? 1 : 0 ;
            //self.types = data[1];
            self.$root.ui.loading = false;
          });
      },
      saveCompany(){
        let self = this;
        self.$validator.validateAll().then(isValid => {
          if(isValid){
              self.$root.ui.loading = true;

              Promise.all([
                  self.$api.saveCompany(self.company, self.file.input_file)
              ]).then(function( data ) {
                  self.$root.ui.loading = false;
                  if( data[0] )
                      self.$router.push('/');
              });
          }
        })
      },
      addImage: function(event) {

          var input = event.target;

          var type = input.dataset.file;

          var self = this;
          self.$root.ui.loading = 'readingFile';

          var input_file = input.files[0];

          if(!input_file){
              return;
          }

          var reader = new FileReader();
          reader.onload = function(event) {

              self.file = {
                  url: reader.result,
                  input_file: input_file
              };

              self.$root.ui.loading = false;
          }

          reader.readAsDataURL(input_file);
          input.value = '';
      },
  },
  created(){
    var self = this;
    self.$root.ui.loading = true;
    self.$api.getWorkshops().then((workshops)=>{
      self.$root.ui.loading = false;
      self.workshops = workshops
      if(self.$route.params.id)
        self.getCompany()
    })
    self.$api.getCompanyTypes().then((data)=>{
        self.types = data
    })
  },
  beforeRouteUpdate: function(to, from, next){
    next()//vm => {}
    if(to.params.id)
      this.getCompany()
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Company.vue?f80ebb62